import { TableColumn } from "../../../../hooks/useResizeableTable";
import { NullPartial } from "../../../../shared/types";

type ContactsTableColumns =
  | "name"
  | "type"
  | "uf"
  | "status"
  | "responsible"
  | "cnpj"
  | "email"
  | "date";

export interface ContactsTableData
  extends NullPartial<Record<ContactsTableColumns, string>> {}

const contactsTableColumns: TableColumn<ContactsTableData>[] = [
  { id: "name", label: "PRODUTOR" },
  { id: "type", label: "TIPO" },
  { id: "uf", label: "UF" },
  { id: "status", label: "STATUS" },
  { id: "responsible", label: "RESPONSÁVEL" },
  { id: "cnpj", label: "CPF/CNPJ" },
  { id: "email", label: "EMAIL" },
  { id: "date", label: "DATA" },
];

export default contactsTableColumns;
